import React from "react";
import "../CreateResume.css";
import "./Create-Resume-Wrapper.css";

const CreateResumeWrapper = ({ title, children }) => {
  return (
    <div className="create-resume-form">
      <div>{title && <span className="create-resume-title">{title}</span>}</div>
      <div className="create-resume-content">{children}</div>
    </div>
  );
};

export default CreateResumeWrapper;
